export class QuarterlyMeasurable {
    id!: string
    name!: string
    goalLabel!: string
    goalValue!: number
    goalValue2!: number | null
    goalDirection!: number // 0: >=, 1: <=, 2: between
    format!: string
    order!: number
    isArchived!: boolean
    hrGoalId!: string | null
    aggregation!: number
    hrGoalName!: string | null
    calculatedSource!: number
    calculatedSourceName!: string | null
}

export class QuarterlyMeasurableValue {
    id!: string
    measurableId!: string
    year!: number
    quarter!: number
    value!: number
}

export class QuarterlyMeasurableDashboardQuarter {
    key!: string
    name!: string
    quarter!: number
    year!: number
    isCurrent!: boolean
}

export class QuarterlyMeasurableDashboardRow {
    id!: string
    name!: string
    goalLabel!: string
    goalValue!: number
    goalValue2!: number | null
    goalDirection!: number
    format!: string
    order!: number
    isMetricLinked!: boolean
    isCalculated!: boolean
    values: Record<string, number | null> = {}
    metricValues: Record<string, number | null> = {}
    sources: Record<string, string> = {}
    drafts: Record<string, number | null> = {}
}

export class QuarterlyMeasurableDashboard {
    quarters: QuarterlyMeasurableDashboardQuarter[] = []
    measurables: QuarterlyMeasurableDashboardRow[] = []
}

export class SaveQuarterlyMeasurableValue {
    measurableId!: string
    year!: number
    quarter!: number
    value!: number | null
}

export class HrGoalLookup {
    id!: string
    name!: string
    order!: number
}
